import styled from '@emotion/styled';

export default styled.div`
	min-width: 100%;
    max-width: 100%;
    margin: 1em 0 1.4em 0;

    .layout-button-google-title {
        margin: 0 0 1em 0;
        font-weight: 500;
        font-size: 1em;
    }
`;
